<template>
    <div class="article-wrap" :style="styleProps">
        <VerifiedBadge
            v-if="$globalConstants.host?.trust_badge"
            :showOnScroll="
                !!$globalConstants.host?.trust_badge_upon_scrolling || false
            "
        />

        <component
            v-if="loaded"
            :is="articleType"
            :article="article"
            v-bind="articlePageProps"
        />
        <Skeleton v-else />
    </div>
</template>

<script>
import { ghostWriterArticleMixin } from '@/ghost-mixins';
import ArticleDefault from '@/application-pages/Article/ArticleDefault';
import Skeleton from '@/components/Skeleton.vue';
export default {
    name: 'ArticleHandler',
    components: {
        Skeleton,
        ArticleDefault,
        ArticleGrid: () => import('@/application-pages/Article/ArticleGrid'),
        ArticleReviewList: () =>
            import('@/application-pages/Article/ArticleReviewList'),
        VerifiedBadge: () =>
            import('@molecules/VerifiedBadge/VerifiedBadge.vue'),
    },
    mixins: [ghostWriterArticleMixin],
    data() {
        return {
            article: {},
            loaded: false,
            pageSlug: null,
            styleProps: this.getGlobalStyle(),
        };
    },
    props: {
        useCategoryEndpoint: {
            type: Boolean,
            default: false,
        },
        slug: null,
        categoryId: null,
        isNonDefaultLanguage: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        getGlobalStyle() {
            let theme = {
                discountButtonBackgroundColor: '#fff',
                discountButtonTextColor: '#09090b',
                discountButtonBorderColor: '#e4e4e7',
                discountButtonSecondaryColor: '#ffffff',
                discountButtonSecondaryTextColor: '#18181b',
                discountButtonSecondaryHoverColor: '#f4f4f5',
                ctaButtonBackgroundColor: '#e11d48',
                ctaButtonTextColor: '#fff',
                partnerHeadlineTextColour: '#173a68',
                highlightBoxBackgroundColor: '#fbfcfc',
                tableHeaderBackgroundColor: '#f4f4f5',
                tableHeaderTextColor: '#71717a',
            };

            const themeSettings =
                this.$globalConstants.components['GhostWriterSettings'] || [];

            if (
                !Array.isArray(themeSettings) &&
                typeof themeSettings === 'object'
            ) {
                theme = { ...theme, ...themeSettings };
            }

            return {
                '--gw-discount-btn-bg-color':
                    theme['discountButtonBackgroundColor'],
                '--gw-discount-btn-secondary-color':
                    theme['discountButtonSecondaryColor'],
                '--gw-discount-btn-secondary-text-color':
                    theme['discountButtonSecondaryTextColor'],
                '--gw-discount-btn-secondary-hover-color':
                    theme['discountButtonSecondaryHoverColor'],
                '--gw-discount-btn-border-color':
                    theme['discountButtonBorderColor'],
                '--gw-discount-btn-text-color':
                    theme['discountButtonTextColor'],
                '--gw-btn-bg-color': theme['ctaButtonBackgroundColor'],
                '--gw-btn-text-color': theme['ctaButtonTextColor'],
                '--gw-partner-headline-text-colour':
                    theme['partnerHeadlineTextColour'],
                '--gw-highlight-box-bg-color':
                    theme['highlightBoxBackgroundColor'],
                '--gw-table-header-bg-color':
                    theme['tableHeaderBackgroundColor'],
                '--gw-table-header-text-color': theme['tableHeaderTextColor'],
            };
        },
    },
    computed: {
        articlePageProps() {
            const pageProps =
                this.$globalConstants.components[this.articleType];

            if (!pageProps) {
                return {};
            }

            return pageProps;
        },
        articleType() {
            if (this.article.layout === 'blog_post') {
                return 'ArticleGrid';
            }

            if (this.article.layout === 'review_list') {
                return 'ArticleReviewList';
            }

            return 'ArticleDefault'; // default layout
        },
    },
};
</script>

<style lang="scss" scoped>
.article-wrap {
    width: 100%;
    max-width: 1200px;
    min-height: 500px;
}
</style>
